import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { GLOBAL_MESSAGING_ID } from '../constants/MessagingConstants';

const getMessagingFromState = state => state.getIn(['ui', 'messaging'], Immutable.Map());

export const getMessaging = createSelector([getMessagingFromState], (messaging) => messaging);

export const getGlobalMessaging = createSelector([getMessaging], (messaging) => messaging.get(GLOBAL_MESSAGING_ID));

export default {
  getMessaging,
  getGlobalMessaging
};



// WEBPACK FOOTER //
// ./app/selectors/MessagingSelector.js